import type { ProductLogoMediumProps } from "../types";

export function ProductLogoMediumFleet({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 672 672"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <path
        d="M384.619 168.008C397.588 168.336 408 178.952 408 192V312C408 325.048 397.588 335.664 384.619 335.992L384 336H192C178.952 336 168.336 325.588 168.008 312.619L168 312V192C168 178.745 178.745 168 192 168H384L384.619 168.008ZM192 312H384V192H192V312Z"
        fill="white"
      />
      <path
        d="M252 156C252 142.745 262.745 132 276 132H300C313.255 132 324 142.745 324 156V180H252V156Z"
        fill="white"
      />
      <path
        d="M278.725 242.474C284.802 240.853 291.199 240.853 297.276 242.474L442.101 281.093C455.918 284.778 463.468 299.653 458.285 312.982L411.459 433.39C407.739 432.475 403.894 432 400 432C387.644 432 375.779 436.764 366.862 445.274L366.009 446.109C359.193 452.945 351.473 456 344 456C336.527 456 328.807 452.945 321.991 446.109C312.986 437.076 300.755 432 288 432C275.644 432 263.779 436.764 254.862 445.274L254.009 446.109C247.193 452.945 239.473 456 232 456C224.527 456 216.807 452.945 209.991 446.109C200.986 437.076 188.755 432 176 432C172.106 432 168.26 432.473 164.54 433.388L117.715 312.982C112.532 299.653 120.082 284.778 133.9 281.093L278.725 242.474Z"
        fill="white"
      />
      <path
        d="M288 468C291.189 468 294.247 469.269 296.498 471.527C309.353 484.42 325.993 492 344 492C360.325 492 375.527 485.771 387.803 475H396V499.083C381.11 509.71 363.28 516 344 516C322.962 516 303.649 508.512 288 496.07C272.351 508.512 253.038 516 232 516C210.962 516 191.649 508.512 176 496.07C160.351 508.512 141.038 516 120 516V492C138.007 492 154.647 484.42 167.502 471.527C169.753 469.269 172.811 468 176 468C179.189 468 182.247 469.269 184.498 471.527C197.353 484.42 213.993 492 232 492C250.007 492 266.647 484.42 279.502 471.527C281.753 469.269 284.811 468 288 468Z"
        fill="white"
      />
      <path
        d="M132 504C132 510.627 126.627 516 120 516C113.373 516 108 510.627 108 504C108 497.373 113.373 492 120 492C126.627 492 132 497.373 132 504Z"
        fill="white"
      />
      <path
        d="M408 487C408 493.627 402.627 499 396 499C389.373 499 384 493.627 384 487C384 480.373 389.373 475 396 475C402.627 475 408 480.373 408 487Z"
        fill="white"
      />
      <path
        d="M432 456H456V516C456 522.627 450.627 528 444 528C437.373 528 432 522.627 432 516V456Z"
        fill="white"
      />
      <path
        d="M564 456H588V516C588 522.627 582.627 528 576 528C569.373 528 564 522.627 564 516V456Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M547.672 384C557.525 384 566.377 390.023 569.995 399.188L586.323 440.554C587.431 443.36 588 446.349 588 449.365V483.2C588 496.455 577.255 507.2 564 507.2H456C442.745 507.2 432 496.455 432 483.2V449.365C432 446.349 432.569 443.36 433.677 440.554L450.005 399.188C453.623 390.023 462.475 384 472.328 384H547.672ZM468 402L456 432H564L552 402H468Z"
        fill="#57D7D9"
      />
      <path
        d="M468 468C468 474.627 462.627 480 456 480C449.373 480 444 474.627 444 468C444 461.373 449.373 456 456 456C462.627 456 468 461.373 468 468Z"
        fill="white"
      />
      <path
        d="M576 468C576 474.627 570.627 480 564 480C557.373 480 552 474.627 552 468C552 461.373 557.373 456 564 456C570.627 456 576 461.373 576 468Z"
        fill="white"
      />
    </svg>
  );
}
